import { render } from "./BrowseArticles.vue?vue&type=template&id=e73bceac&scoped=true&ts=true"
import script from "./BrowseArticles.ts?vue&type=script&lang=ts"
export * from "./BrowseArticles.ts?vue&type=script&lang=ts"

import "./BrowseArticles.vue?vue&type=style&index=0&id=e73bceac&scoped=true&lang=scss"

import exportComponent from "D:\\Melinda\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e73bceac"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QBtn,QIcon,QTable,QTr,QTd,QInput,QToggle,QCircularProgress});qInstall(script, 'directives', {Ripple});
